import Overview from '@rebuild/materials/shared/investment_activity/BaseOverview.vue';
import FullIndex from '@rebuild/materials/shared/investment_activity/FullIndex.vue';
import RoadshowIndex from '@rebuild/materials/shared/investment_activity/RoadshowIndex.vue';
import OfflineIndex from '@rebuild/materials/shared/investment_activity/OfflineIndex.vue';
import ResearchIndex from '@rebuild/materials/shared/investment_activity/ResearchIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/investment_activity/context';

function useSelfContext() {
	provideCurrentContext({
		viewInHK09606: true
	});
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(FullIndex, useSelfContext),

	roadshow: withProvider(RoadshowIndex, useSelfContext),
	offline: withProvider(OfflineIndex, useSelfContext),
	research: withProvider(ResearchIndex, useSelfContext)
};
